import { type AggRequest, fetchAgg } from '../../../../common/utils/fetch-agg';

import { operationName, quickFindUserDocumentsQuery } from './query';
import {
	type QuickFindUserDocumentsQueryType,
	type QuickFindUserDocumentsQueryVariables,
} from './types';

export type QuickFindUserDocumentsQueryProps = Pick<
	AggRequest<QuickFindUserDocumentsQueryVariables>,
	'aggAbsoluteUrl' | 'variables'
>;

export const userDocumentsQuery = ({
	variables,
	aggAbsoluteUrl,
}: QuickFindUserDocumentsQueryProps) => {
	return fetchAgg<QuickFindUserDocumentsQueryVariables, QuickFindUserDocumentsQueryType>({
		variables,
		aggAbsoluteUrl,
		graphQuery: quickFindUserDocumentsQuery,
		operationName,
	});
};
